import { NgModule } from "@angular/core";
import { RegistrationComponent } from "./registration.component";
import { L10nTranslationModule } from "angular-l10n";
import { RegistrationWizardComponent } from "./registration-wizard.component";
import { RegistrationWizardStepComponent } from "./registration-wizard-step.component";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { RecaptchaModule } from "ng-recaptcha";
import { CommonModule } from "@angular/common";
import { NgSelectModule } from "@ng-select/ng-select";
import { routes } from "./registration.routes";
import { RouterModule } from "@angular/router";
import { DialogModule } from "primeng/dialog";
import { DisclaimerModule } from "../disclaimer/disclaimer.module";
import { PasswordStrengthBarModule } from "../../helpers/passwordStrengthBar/passwordStrengthBar.module";
import { HeaderModule } from "../header/header.module";
import { FooterModule } from "../footer/footer.module";
import { NgOptionHighlightModule } from "@ng-select/ng-option-highlight";
import { FontAwesomeModule } from "@fortawesome/angular-fontawesome";

@NgModule({
  declarations: [
    RegistrationComponent,
    RegistrationWizardComponent,
    RegistrationWizardStepComponent
  ],
  exports: [
    RegistrationWizardComponent,
    RegistrationWizardStepComponent
  ],
    imports: [
        L10nTranslationModule,
        CommonModule,
        HeaderModule,
        FooterModule,
        ReactiveFormsModule,
        NgSelectModule,
        RecaptchaModule,
        RouterModule.forChild(routes),
        DialogModule,
        DisclaimerModule,
        PasswordStrengthBarModule,
        NgOptionHighlightModule,
        FormsModule,
        FontAwesomeModule
    ]
})

export class RegistrationModule {
  public static routes = routes;
}
